import classNames from 'classnames';

export const BannersFilters = ({ basicGrid }: { basicGrid?: string }) => {
  return (
    <div
      className={classNames(
        `sticky top-[12%] mx-auto mb-[4px] mt-6 flex 
  h-14 w-[1280px] items-start justify-start gap-8
  self-stretch rounded-[16px] border-[1px] border-[#F3F3F3] bg-[#FFF] px-6 py-4 text-lg font-normal not-italic leading-6 text-[color:var(--Simple-Gray-Midnight,#7D7D7D)] transition-all duration-75`,
        basicGrid
      )}
    >
      <div className='col-span-1 w-[196px]'>Раздел</div>
      <div className='col-span-1 w-[496px]'>Название</div>
      <div className='col-span-1 w-[196px]'>Статус</div>
      <div className='col-span-1 w-[196px]'>Формат</div>
      <div className='col-span-1 w-[260px]'>Период показа</div>
    </div>
  );
};
